import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../components/filter-select-field/filter-select-field.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';
import { FILTER_VALUE_EMPTY } from '../../../constants/system/filter-values';
import { FILTER_TYPE_COMPANY_ID, FILTER_TYPE_ACCESS_LEVEL } from '../../../constants/system/filter-types';

const DealParticipantsFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    currentFilters,
    filters,
    filterDealParticipantCompanyList,
    filterDealParticipantAccessLevelList,
    onSetFilterValue,
  } = props;

  const filterContactCompanyId: number = filters && filters[FILTER_TYPE_COMPANY_ID];
  const filterAccessLevel: string = filters && filters[FILTER_TYPE_ACCESS_LEVEL];

  const menuItemFilterDealParticipantCompanyList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'fullName',
    optionList: filterDealParticipantCompanyList,
    selectedValue: filterContactCompanyId,
  }), [filterDealParticipantCompanyList, filterContactCompanyId]);

  const menuItemFilterDealParticipantAccessLevelList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterDealParticipantAccessLevelList,
    selectedValue: filterAccessLevel,
  }), [filterDealParticipantAccessLevelList, filterAccessLevel]);

  return (
    <FilterContainer>
      {
        filterDealParticipantCompanyList && !!filterDealParticipantCompanyList.length && (
          <FilterSelectField
            isInteger
            filterType={FILTER_TYPE_COMPANY_ID}
            label="Company"
            value={currentFilters[FILTER_TYPE_COMPANY_ID] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterDealParticipantCompanyList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
      {
        filterDealParticipantAccessLevelList && !!filterDealParticipantAccessLevelList.length && (
          <FilterSelectField
            filterType={FILTER_TYPE_ACCESS_LEVEL}
            label="Access Level"
            value={currentFilters[FILTER_TYPE_ACCESS_LEVEL] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterDealParticipantAccessLevelList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
    </FilterContainer>
  );
});

export default DealParticipantsFilters;
